import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type CaseFixedBase from "@/components/CaseFixed.Base.vue";

export default defineMosaicComponent<typeof CaseFixedBase>("components/CaseFixed");
